import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg, Kind } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const PENDING_COMPANY_KEY = "eeh_pending_company";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin(kind: Kind, next: string, companyName?: string) {
  if (companyName) sessionStorage.setItem(PENDING_COMPANY_KEY, companyName);
  else sessionStorage.removeItem(PENDING_COMPANY_KEY);
  const redirectUrl = `${window.location.origin}/auth/callback?kind=${kind}&next=${encodeURIComponent(next)}`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");
  const [backTo, setBackTo] = useState("/login");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const params = new URLSearchParams(location.search);
    const k = params.get("kind");
    const kind = (k === "vendor" || k === "admin" ? k : "customer") as Kind;
    const next = params.get("next") || (kind === "vendor" ? "/dashboard" : kind === "admin" ? "/admin" : "/me");
    setBackTo(kind === "vendor" ? "/login" : kind === "admin" ? "/admin/login" : "/attendee");
    const company_name = sessionStorage.getItem(PENDING_COMPANY_KEY) || undefined;
    api.post("/auth/google", { session_id: sessionId, kind, company_name })
      .then(async ({ data }) => {
        sessionStorage.removeItem(PENDING_COMPANY_KEY);
        await signIn(kind, data.token);
        nav(next.startsWith("/") ? next : "/", { replace: true });
      })
      .catch((e) => setError(errMsg(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-background p-6 text-center" data-testid="auth-callback">
      {error ? (
        <div className="max-w-sm space-y-4">
          <p className="text-sm text-rose-600" data-testid="auth-callback-error">{error}</p>
          <Link to={backTo} className="font-semibold text-primary" data-testid="auth-callback-back-link">Back to login</Link>
        </div>
      ) : <Loader2 className="h-6 w-6 animate-spin text-primary" />}
    </div>
  );
}
